/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { Logger } from "@html-core";

import * as protobuf from "../../../../proto/rtav_pb";

@Injectable({
   providedIn: "root"
})
export class ProtobufService {
   constructor() {}

   public serializeVideoDeviceResolution(data): Uint8Array {
      const message = protobuf.RTAV.VideoDeviceResolution.create(data);
      return protobuf.RTAV.VideoDeviceResolution.encode(message).finish();
   }

   public deserializeVideoDeviceResolution(data: Uint8Array) {
      return protobuf.RTAV.VideoDeviceResolution.decode(data);
   }

   public serializeAdminPolicy(data): Uint8Array {
      const message = protobuf.RTAV.AdminPolicy.create(data);
      return protobuf.RTAV.AdminPolicy.encode(message).finish();
   }

   public deserializeAdminPolicy(data: Uint8Array) {
      return protobuf.RTAV.AdminPolicy.decode(data);
   }

   public serializeClientConfig(data): Uint8Array {
      const message = protobuf.RTAV.ClientConfig.create(data);
      return protobuf.RTAV.ClientConfig.encode(message).finish();
   }

   public deserializeClientConfig(data: Uint8Array) {
      return protobuf.RTAV.ClientConfig.decode(data);
   }

   public serializeAudioDeviceList(data): Uint8Array {
      var audioDeviceListJson = {};
      audioDeviceListJson["count"] = data.length;
      audioDeviceListJson["devices"] = data;
      const audioDeviceList = protobuf.RTAV.AudioDeviceList.fromObject(audioDeviceListJson);
      return protobuf.RTAV.AudioDeviceList.encode(audioDeviceList).finish();
   }

   public serializeVideoDeviceList(data): Uint8Array {
      var videoDeviceListJson = {};
      videoDeviceListJson["count"] = data.length;
      videoDeviceListJson["devices"] = data;
      const videoDeviceList = protobuf.RTAV.VideoDeviceList.fromObject(videoDeviceListJson);
      return protobuf.RTAV.VideoDeviceList.encode(videoDeviceList).finish();
   }

   public deserializeAudioDevicePref(data: Uint8Array) {
      return protobuf.RTAV.AudioDevicePrefs.decode(data);
   }

   public deserializeVideoDevicePref(data: Uint8Array) {
      return protobuf.RTAV.VideoDevicePrefs.decode(data);
   }

   public serializeAudioDevicePref(audioDevicePref) {
      return protobuf.RTAV.AudioDevicePrefs.encode(audioDevicePref).finish();
   }

   public serializeVideoDevicePref(videoDevicePref) {
      return protobuf.RTAV.VideoDevicePrefs.encode(videoDevicePref).finish();
   }
}

export const protobufService = new ProtobufService();
